import i18n from 'services/base/i18n';

export default {
  port:         () => i18n.pgettext('Components|List History|Filter History|Protocol Input', 'Please specify the transport protocol and a port number.'),
  range:        () => i18n.pgettext('Components|List History|Filter History|Protocol Input', 'Please specify the transport protocol and the port range.'),
  save:         () => i18n.pgettext('Components|List History|Filter History|Protocol Input', 'OK'),
  invalidPort:  () => i18n.pgettext('Components|List History|Filter History|Protocol Input', 'Port numbers must be within 0 - 65535.'),
  invalidRange: () => i18n.pgettext('Components|List History|Filter History|Protocol Input', 'Port numbers must be within 0 - 65535.'),
};
